import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconTelegram = forwardRef<SVGSVGElement, IconProps>(
  function IconTelegram(props, ref) {
    const { className, title, titleId, ...otherProps } = props
    const defaultClasses =
      "w-8 h-8 flex-shrink-0 transition-colors duration-150 ease-in focus:outline-none"
    const classes = mergeClasses(defaultClasses, className)

    return (
      <svg
        ref={ref}
        viewBox="0 0 32 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        tabIndex={-1}
        className={classes}
        aria-labelledby={titleId}
        {...otherProps}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
          d="M30.4 2.34209C30.2 2.24209 30 2.24209 29.8 2.34209L1.3 15.5421C1.1 15.6421 1 15.8421 1 16.1421C1 16.3421 1.2 16.5421 1.4 16.6421L10.6 20.3421L13.5 30.6421C13.5 30.7421 13.6 30.7421 13.6 30.8421L13.7 30.9421H13.8C13.9 30.9421 14 30.9421 14 30.9421H14.1H14.2C14.3 30.9421 14.3 30.8421 14.4 30.8421L21.7 24.8421C21.7 24.8421 21.7 24.8421 21.8 24.7421L27.8 27.2421C27.9 27.2421 28 27.3421 28 27.2421C28.1 27.2421 28.2 27.2421 28.3 27.1421C28.5 27.0421 28.6 26.8421 28.6 26.6421L30.6 2.64209C30.6 2.64209 30.5 2.44209 30.4 2.34209ZM15.5 21.5421C15.5 21.6421 15.5 21.6421 15.5 21.6421L14 28.1421L11.7 20.1421L22 11.4421L15.5 21.5421ZM15 28.9421L16.4 22.6421L20.5 24.3421L15 28.9421ZM27.5 25.9421L16.9 21.5421L25.2 8.84209C25.4 8.64209 25.3 8.24209 25.1 8.04209C24.9 7.84209 24.5 7.84209 24.3 8.04209L10.9 19.2421L3.1 16.0421L29.3 3.84209L27.5 25.9421Z"
          fill={props.fill || "black"}
        />
      </svg>
    )
  },
)
